import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type ListFilter } from '../types/filters';

export const employmentRelationshipDefinition: FilterDefinition<ListFilter> = {
  id: FilterId.EMPLOYMENT_RELATIONSHIP,
  name: 'Employment Type',
  selectionListId: 'employment_relationship',
  selections: [],
  type: FilterType.LIST,
  isVisible: true,
};

export const employmentRelationshipHandler: FilterHandler<ListFilter> = {
  isActive(currentFilterState: ListFilter) {
    return currentFilterState.selections.length > 0;
  },
  isDefault(currentFilterState: ListFilter) {
    return currentFilterState.selections.length === 0;
  },
  getEffectiveFilter(currentFilterState: ListFilter) {
    return { ...currentFilterState };
  },
  getRequiredSelectionListIds(definition: FilterDefinition<ListFilter>) {
    return [definition.selectionListId];
  },
};
